import * as React from 'react'
import { BulkActionButton } from '../BulkActionButton'

type Props = { hasPermission: boolean }

export const BulkUpdateStatusButton: React.FC<Props> = (props) => (
  <BulkActionButton
    type="updateSalesFunnel"
    helperText="Update the status/stage for multiple records in a sales funnel. Records must be in an open state to perform this action."
    hasPermission={props.hasPermission}
    errorString="You do not have permission to perform bulk updates."
  >
    Update Sales Funnel
  </BulkActionButton>
)
BulkUpdateStatusButton.displayName = 'BulkUpdateStatusButton'
